import Accordion from "./imports/accordion.js";
import Carousel from "./imports/carousel.js";
import ClearForm from "./imports/clear-form.js";
import Comparison from "./imports/comparison.js";
import Facet from "./imports/facet.js";
import Gallery from "./imports/gallery.js";
import HeroPattern from "./imports/hero-pattern.js";
import HeroVideo from "./imports/hero-video.js";
import HotspotImage from "./imports/hotspot-image.js";
import InternalNav from "./imports/internal-nav.js"; // To be deleted
import OffCanvas from "./imports/off-canvas.js";
import ResponsiveTable from "./imports/responsive-table.js";
import ScrollbarWidth from "./imports/scrollbar-width.js";
import ScrollSpy from "./imports/scroll-spy.js";
import Tabs from "./imports/tabs.js";

import GraphicalAccordion from "./imports/refresh/graphical-accordion.js";
import Header from "./imports/refresh/header.js";
import HeaderSearchQuickLinks from "./imports/refresh/header-search-quick-links.js";
import Hero from "./imports/refresh/hero.js";
import InPageNavigation from "./imports/refresh/in-page-navigation.js";
import LazyLoadVideos from "./imports/refresh/lazy-load-videos.js";
import Modal from "./imports/refresh/modal.js";
import SearchableSelect from "./imports/refresh/searchable-select.js";
import StickyOffset from "./imports/refresh/sticky-offset.js";
import mpTabs from "./imports/refresh/mp-tabs.js";
import VerticalTabs from "./imports/refresh/vertical-tabs.js";

export default function initializeApp() {
  // Polyfills
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
  if (window.HTMLCollection && !HTMLCollection.prototype.forEach) {
    HTMLCollection.prototype.forEach = Array.prototype.forEach;
  }

  // Initialize components
  Accordion();
  Carousel();
  ClearForm();
  Comparison();
  Facet();
  Gallery();
  HeroPattern();
  HeroVideo();
  HotspotImage();
  InternalNav(); // To be deleted
  OffCanvas();
  ResponsiveTable();
  ScrollbarWidth();
  ScrollSpy();
  Tabs();
  VerticalTabs();

  GraphicalAccordion();
  Header();
  HeaderSearchQuickLinks();
  Hero();
  InPageNavigation();
  LazyLoadVideos();
  Modal();
  SearchableSelect();
  StickyOffset();
  mpTabs();
}

if (typeof window !== "undefined") {
  initializeApp();
}
